import React, { useState } from "react";
import { connect } from "react-redux";
import { Layout } from "../components/Layout";
import { FieldDiv } from "../components/FieldDiv";
import { selectUser } from "../store/reducers";
import ErrorIcon from "@material-ui/icons/Error";
import { PopDetails } from "../components/PopDetails";
import { SmallButton } from "../components/alerts/styles";
import { firebase } from "../utils/alias";
import { isTest } from "../store/sagas/initialiseFirebase";
import { Switch } from "@material-ui/core";
import styled from "styled-components";

const Root = styled.div`
    text-align: center;
`;

const Section = styled.div`
    margin-top: 2rem;
`;

const VerificationIcon = ({ emailVerified }) => {
    if (emailVerified) {
        return (
            <PopDetails
                details="Verified"
                icon={<i className="nes-icon is-small like" />}
            />
        );
    }
    return <PopDetails details="Not verified" icon={<ErrorIcon />} />;
};

const RequestVerification = () => {
    const [requested, setRequested] = useState(false);
    if (!requested) {
        return (
            <SmallButton
                onClick={() => {
                    if (!isTest) {
                        firebase.auth().currentUser.sendEmailVerification();
                    }
                    setRequested(true);
                }}
            >
                Resend verification email
            </SmallButton>
        );
    }
    return "Sent!";
};

const _NotificationsSection = ({ notificationPermissions, setPermission }) => (
    <Section>
        <h3>Notifications</h3>
        <FieldDiv>
            <label>Reminders:</label>{" "}
            <Switch
                onChange={e => setPermission({ reminders: e.target.checked })}
                checked={
                    notificationPermissions && notificationPermissions.reminders
                }
            />
        </FieldDiv>
        <FieldDiv>
            <label>Important updates:</label>{" "}
            <Switch
                onChange={e => setPermission({ updates: e.target.checked })}
                checked={
                    notificationPermissions && notificationPermissions.updates
                }
            />
        </FieldDiv>
    </Section>
);

const _dispatchActions = {
    setPermission: notificationPermissions => ({
        type: "REQUEST_UPDATE_USER",
        details: { notificationPermissions }
    })
};

const _mapState = state => ({
    ...selectUser(state)
});

const NotificationsSection = connect(
    _mapState,
    _dispatchActions
)(_NotificationsSection);

const _Account = ({ displayName, email, auth: { emailVerified } }) => (
    <Layout>
            <Root>
            <Section>
                <h3>Info</h3>
                <FieldDiv>
                    User name: <span data-hj-suppress>{displayName}</span>
                </FieldDiv>
                <FieldDiv>
                    <div>
                        Email: {email} <VerificationIcon {...{ emailVerified }} />
                    </div>
                    {!emailVerified && <RequestVerification />}
                </FieldDiv>
            </Section>

            <NotificationsSection />
        </Root>
    </Layout>
);

const dispatchActions = {
    login: loginDetails => ({
        type: "LOGIN",
        loginDetails
    })
};

const mapState = state => ({
    ...selectUser(state)
});

const Account = connect(
    mapState,
    dispatchActions
)(_Account);

export { Account };



// WEBPACK FOOTER //
// ./src/pages/Account.js